import _default from './Radio';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/addons/Radio/index.js
// module id = 633
// module chunks = 1